<template>
  <div class="filters">
    <label
        v-for="filter of filters"
        :key="filter.value"
        class="filters__label">
      <input
        @change="$emit('change', $event.target.value)"
        type="radio"
        :name=name
        :value="filter.value"
        :checked="filter.value === value"
      >
      <span class="filters__item">{{ filter.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppFilters',
  props: {
    filters: {
      type: Array,
      required: true,
    },
    name: String,
    value: {
      type: String,
    }
  },
  model: {
    event: 'change',
    prop: 'value'
  }
}
</script>

<style scoped lang="sass">
@import "@/assets/common/index.scss"

.filters
  display: flex
  flex-shrink: 0
  overflow: hidden
  border: 1px solid $color-border
  border-radius: 7px

  input[type="radio"]
    +visually-hidden

    &:checked + .filters__item
      background-color: $color-theme
      color: #fff
      pointer-events: none

.filters__label
  border-right: 1px solid $color-border

  &:last-child
    border: none

.filters__item
  display: block
  padding: 15px 24px

  background-color: #f8fdff
  font-size: 16px
  cursor: pointer
  transition: opacity 0.3s

  &:active
    opacity: 0.7

  @media (hover: hover)
    &:hover,
    &:focus
      opacity: 0.7

</style>
